<template>
<PrimeBreadcrumb  :home="home" :model="items" style="margin-top: 0px;"></PrimeBreadcrumb>
<!--DataGrid -->
<button type="button" class="btn btn-danger" @click="add">
          <font-awesome-icon icon="plus" />New
        </button>
  <div class="card">
    <PrimeDataTable
      ref="dt"
      :value="data"
      :paginator="true"
      :rows="10"
      dataKey="pkey"
    >
      
      <PrimeColumn :exportable="false" style="width: 6rem">
        <template #body="slotProps">
          <div class="btn-group" role="group">
            <button class="btn btn-success" @click="edit(slotProps.data)">
               <font-awesome-icon icon="edit" />
            </button>
            <button
              class="btn btn-outline-success"
              @click="confirmDelete(slotProps.data)"
            >
              <font-awesome-icon icon="trash" />
            </button>
          </div>
        </template>
      </PrimeColumn>

<PrimeColumn field="year" header="年度" :sortable="true"></PrimeColumn>
<PrimeColumn field="hcTedelno_Start_9" header="起始編號" :sortable="true"></PrimeColumn>
<PrimeColumn field="hcTedelno_End_9" header="結束編號" :sortable="true"></PrimeColumn>
  
<PrimeColumn header="總數">
      <template #body="slotProps">
          <span>{{slotProps.data.hcTedelno_End_9 - slotProps.data.hcTedelno_Start_9 + 1 }}</span>
      </template>
</PrimeColumn>
<PrimeColumn header="使用率">
      <template #body="slotProps">
          <span>{{Number((slotProps.data.hcTedelno_Used / (slotProps.data.hcTedelno_End_9 - slotProps.data.hcTedelno_Start_9 + 1))*100).toFixed(2)}}%</span>
      </template>
</PrimeColumn>
     <PrimeColumn header="客戶預取號">
      <template #body="slotProps">
          <span>
            <PrimeButton
          label="開啟客戶預取號"
          icon="pi pi-check"
          class="p-button-success"
          @click="open(slotProps.data.pkey)"
        />
        <span>
            <PrimeButton
          label="區間號狀況"
          icon="pi pi-check"
          class="p-button-primary"
          @click="open2(slotProps.data.pkey)"
        />
         </span>
         </span>
      </template>
</PrimeColumn>
 
     
    </PrimeDataTable>
  </div>


 <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog"
    :style="{ width: '950px' }"
    header="代理區間號維護"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name"
      :item="item"
      @save="detailSave"
      @close="detailClose"
    ></component>
  </PrimeDialog>


<!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowCustRangeDialog"
    :style="{ width: '950px' }"
    header="客戶預取號"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name1"
      :parentpkey="parentpkey"
      :minno="minno"
      :maxno="maxno"
      @save="detailSave"
      @close="detailClose"
    ></component>
  </PrimeDialog>

<!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog2"
    :style="{ width: '950px' }"
    header="區間號使用狀況"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name2"
      :parentpkey="parentpkey"
       :custparentpkey="custparentpkey"
     ></component>
  </PrimeDialog>

  <PrimeConfirmDialog></PrimeConfirmDialog>

</template>

<script>
import service from "../service/Appservice";
export default {
   props: ["agentNo"],
  
  data() {
    return {
      isAddNew: false,
      component_name: "my-modal-agent-hctedelno-range",
      component_name1: "my-agent-cust-hctedelno-range",
      component_name2: "my-hctedelno",

      item: null,
      selectedItems: null,
      data: null,
      isShowDialog: false,
      isShowDialog2: false,
      keyField: "pkey",


      parentpkey:null,
      isShowCustRangeDialog: false,
      minno:null,
      maxno:null,
     custparentpkey:0,

       home: {icon: 'pi pi-home', to: '/'},
            items: [
                {label: '代理'} ,
                {label: '代理維護'} ,
                {label: '代理區間號'} 
            ]
    };
  },
  computed: {
   
   user() {
     return this.$store.state.user;
    },
     clientId() {
     return this.$store.state.user?.clientId;
    },
     
  },
  service: null,
  created() {
    this.service = new service();
  },
  mounted() {
    this.search();
  },
  methods: {
   /////對話視窗回復事件/////////////////////////////////
    detailSave: function (obj) {
      this.isShowDialog = false;
      if (this.isAddNew) {
        this.array_addItem(this.data, obj);
      } else {
        this.array_updateItem(this.data, obj, this.keyField);
      }
    },

    detailClose: function () {
      this.isShowDialog = false;
    },
    open(pkey,minno,maxno){

      console.log('open')
      console.log(pkey)
      this.parentpkey=pkey;
      this.minno=minno;
      this.maxno=maxno;
      this.isShowCustRangeDialog = true;

    }
    ,
     open2(pkey) {
      this.parentpkey=pkey;
       this.isShowDialog2 = true;
    },
    ////////搜尋/////////////////////////////////////
    search() {
      this.service
        .getAgentHCTedelnoRange(this.clientId,this.agentNo)
        .then((data) => {
          console.log(data)
          this.data = [...data];
        });
    },
    //////新增,修改,刪除////////////////////////////////////////////
    add() {
      this.isAddNew=true;
       this.item={};
       this.item.year = new Date().getFullYear();
       this.item.clientId=this.clientId;
       this.item.agentNo=this.agentNo;
       this.isShowDialog = true;
    },
    edit(rowSelect) {
      this.isAddNew=false;
      console.log('edit')
      console.log(rowSelect)
      this.item=rowSelect;
      this.isShowDialog = true;
    },
    confirmDelete(selectItem) {
      
       var yes = confirm('你確定要刪除?');

        if (yes) {
            console.log(selectItem);
            this.delete(selectItem);
        } 
      

    },
    delete(selectItem) {
      var self = this;
      this.service
        .deleteAgentHCTedelnoRange(selectItem)
        .then(() => {
          this.array_deleteItem(self.data, selectItem, self.keyField);
        });
    },
  }
}
</script>
 